import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Header from '../../components/header/Header';
import EmergencyHeader from '../../components/header/EmergencyHeader';
import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';

import UpdateOrganisation from '../../components/organisations/UpdateOrganisation';
import UpdateFireLogSettings from '../../components/organisations/UpdateFireLogSettings';
import UpdatePlannedEventSettings from '../../components/organisations/UpdatePlannedEventSettings';
import ListOfUsers from '../../components/users/ListOfUsers';
import Integrations from '../../components/settings/Integrations';
import MobileEnrolment from '../../components/settings/MobileEnrolment';
import TidyUp from '../../components/settings/TidyUp';
import LocationSettings from '../../components/settings/LocationSettings';
import EmailTemplates from '../../components/settings/EmailTemplates';
import DataRetention from '../../components/settings/DataRetention';

import UserForm from '../../forms/Users';

import PopupBox from '../../components/shared/PopupBox';

import { adminUser, managerUser, reportingUser, retailUser } from '../../utilities/Forms.js'

import BtnOrganisation from '../../images/btn_organisation_1075_725.png';
import BtnUsers from '../../images/btn_users_1075_725.png';
import BtnFireLog from '../../images/btn_fire_log_1075_725.png';
import BtnPlannedEvents from '../../images/btn_planned_events_1075_725.png';
import IntegrationsIcon from '../../images/integrations.png';
import EnrolmentIcon from '../../images/enrolment.png';
import TidyUpIcon from '../../images/tidy_up.png';
import BooksIcon from '../../images/books.png';
import LocationIcon from '../../images/location.png';
import EmailIcon from '../../images/email.png';

class SettingsIndex extends Component {
  constructor(props) {
    super(props);

    this.updatePopupCallback = this.updatePopupCallback.bind(this);
  }

  state = {
    page: "index"
  };

  currentPage(page) {
    if (page === this.state.page) {
      return "current-page"
    }
  }

  updatePopupCallback(id) {
    this.setState({
      resetId: id
    })
  }

  renderSettingsIndex() {
    const baseLicense = localStorage.license === "base"

    if (this.state.page === "index") {
      if (adminUser() || managerUser()) {
        return (
          <div>
            <SetTitle title={"Settings"} />
            <h2 className="page-title">Settings</h2>
            <OrganisationName />

            <div>
              <p>Welcome to your settings page. Below you can select different types of settings you may want to explore.</p>
            </div>

            {adminUser() && (
              <Link to={"/settings/organisation"}>
                <div className="widget exports-page" style={{ backgroundImage: `url(${BtnOrganisation})`}}>
                  <h3 className="title">Organisation Settings</h3>
                </div>
              </Link>
            )}

            {adminUser() && retailUser() && (
              <Link to={"/settings/location"}>
                <div className="widget exports-page" style={{ backgroundImage: `url(${LocationIcon})`}}>
                  <h3 className="title">Location Settings</h3>
                </div>
              </Link>
            )}

            {baseLicense && (
              <Link to={"/settings/fire-log"}>
                <div className="widget exports-page" style={{ backgroundImage: `url(${BtnFireLog})`}}>
                  <h3 className="title">Fire Log Settings</h3>
                </div>
              </Link>
            )}

            {baseLicense && (
              <Link to={"/settings/appointments"}>
                <div className="widget exports-page" style={{ backgroundImage: `url(${BtnPlannedEvents})`}}>
                  <h3 className="title">Appointment Settings</h3>
                </div>
              </Link>
            )}

            {baseLicense && (
              <Link to={"/settings/email-templates"}>
                <div className="widget exports-page" style={{ backgroundImage: `url(${EmailIcon})`}}>
                  <h3 className="title">Email Template Settings</h3>
                </div>
              </Link>
            )}

            {(adminUser() || managerUser()) && (
              <Link to={"/settings/users"}>
                <div className="widget exports-page" style={{ backgroundImage: `url(${BtnUsers})`}}>
                  <h3 className="title">User Settings</h3>
                </div>
              </Link>
            )}

            {(adminUser() || managerUser()) && !retailUser() && (
              <Link to={"/settings/integrations"}>
                <div className="widget exports-page" style={{ backgroundImage: `url(${IntegrationsIcon})`}}>
                  <h3 className="title">Integrations</h3>
                </div>
              </Link>
            )}

            {baseLicense && (
              <Link to={"/settings/enrolment"}>
                <div className="widget exports-page" style={{ backgroundImage: `url(${EnrolmentIcon})`}}>
                  <h3 className="title">Mobile Enrolment</h3>
                </div>
              </Link>
            )}

            {adminUser() && (
                <Link to={"/settings/data-retention"}>
                  <div className="widget exports-page" style={{ backgroundImage: `url(${BooksIcon})`}}>
                    <h3 className="title">Data Retention</h3>
                  </div>
                </Link>
              )}

            {(adminUser() || managerUser()) && (
                <Link to={"/settings/tidy-up"}>
                  <div className="widget exports-page" style={{ backgroundImage: `url(${TidyUpIcon})`}}>
                    <h3 className="title">Data Tidy Up</h3>
                  </div>
                </Link>
              )}
          </div>
        )
      }
      else {
        return (
          <div>
            <SetTitle title={"Settings"} />
            <h2 className="page-title">Settings</h2>
            <OrganisationName />

            <div>
              <p>You do not have access to edit core settings. To change your access level, please contact one of your administrators.</p>
            </div>
          </div>
        )
      }
    }
  }

  renderPages() {
    switch (this.state.page) {
      case "organisation":
        return (
          <div>
            <SetTitle title={"Organisation Settings | Settings"} />
            <h2 className="page-title">Organisation Settings</h2>
            <OrganisationName />
            <PopupBox />
            <UpdateOrganisation updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      case "location":
        return (
          <div>
            <SetTitle title={"Location Settings | Settings"} />
            <h2 className="page-title">Location Settings</h2>
            <OrganisationName />
            <PopupBox />
            <LocationSettings updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      case "users":
        return (
          <div>
            <SetTitle title={"User Settings | Settings"} />
            <h2 className="page-title">User Settings</h2>
            <OrganisationName />
            <PopupBox />
            <ListOfUsers userId={this.props.match.params.user_id} updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      case "fire-log":
        return (
          <div>
            <SetTitle title={"Fire Log Settings | Settings"} />
            <h2 className="page-title">Fire Log Settings</h2>
            <OrganisationName />
            <PopupBox />
            <UpdateFireLogSettings updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      case "appointments":
        return (
          <div>
            <SetTitle title={"Appointment Settings | Settings"} />
            <h2 className="page-title">Appointment Settings</h2>
            <OrganisationName />
            <PopupBox />
            <UpdatePlannedEventSettings updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      case "email-templates":
        return (
          <div>
            <SetTitle title={"Email Template Settings | Settings"} />
            <h2 className="page-title">Email Template Settings</h2>
            <OrganisationName />
            <PopupBox />
            <EmailTemplates updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      case "integrations":
        return (
          <div>
            <SetTitle title={"Integrations | Settings"} />
            <h2 className="page-title">Integrations</h2>
            <OrganisationName />
            <PopupBox />
            <Integrations updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      case "enrolment":
        return (
          <div>
            <SetTitle title={"Mobile Enrolment | Settings"} />
            <h2 className="page-title">Mobile Enrolment</h2>
            <OrganisationName />
            <PopupBox />
            <MobileEnrolment updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      case "data-retention":
        return (
          <div>
            <SetTitle title={"Data Retention | Settings"} />
            <h2 className="page-title">Data Retention</h2>
            <OrganisationName />
            <PopupBox />
            <DataRetention updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      case "tidy-up":
        return (
          <div>
            <SetTitle title={"Data Tidy Up | Settings"} />
            <h2 className="page-title">Data Tidy Up</h2>
            <OrganisationName />
            <PopupBox />
            <TidyUp updatePopupCallback={this.updatePopupCallback} />
          </div>
        );
      default:
        return this.renderSettingsIndex()
    }
  }

  render() {
    const baseLicense = localStorage.license === "base"

    if (adminUser() || managerUser()) {
      return (
        <div>
          <Header />

          <div className="settings-page">
            <div className="sidebar">
              <Link to={"/settings"} className={this.currentPage("index")}>List of Settings</Link>
              {adminUser() && (<Link to={"/settings/organisation"} className={this.currentPage("organisation")}>Organisation Settings</Link>)}
              {adminUser() && retailUser() && (<Link to={"/settings/location"} className={this.currentPage("location")}>Location Settings</Link>)}
              {baseLicense && (<Link to={"/settings/fire-log"} className={this.currentPage("fire-log")}>Fire Log Settings</Link>)}
              {baseLicense && (<Link to={"/settings/appointments"} className={this.currentPage("appointments")}>Appointment Settings</Link>)}
              {baseLicense && (<Link to={"/settings/email-templates"} className={this.currentPage("email-templates")}>Email Template Settings</Link>)}
              <Link to={"/settings/users"} className={this.currentPage("users")}>User Settings</Link>
              {(adminUser() || managerUser()) && !retailUser() && (<Link to={"/settings/integrations"} className={this.currentPage("integrations")}>Integrations</Link>)}
              {baseLicense && (<Link to={"/settings/enrolment"} className={this.currentPage("enrolment")}>Mobile Enrolment</Link>)}
              {adminUser() && (<Link to={"/settings/data-retention"} className={this.currentPage("data-retention")}>Data Retention</Link>)}
              {adminUser() && (<Link to={"/settings/tidy-up"} className={this.currentPage("tidy-up")}>Data Tidy Up</Link>)}
            </div>
            <div className="main-content">
              <div className="main-page">
                {this.renderPages()}
              </div>
            </div>
          </div>
        </div>
      );
    }
    else {
      return (
        <div>
          {/*
            Display the Emergency header for Emergency-only Users,
            as the network requests in the main Header would fail for them
          */}
          { !reportingUser() ? <EmergencyHeader /> : <Header /> }

          <div className="settings-page">
            <div></div>
            <div className="main-content">
              <div className="main-page">
                <SetTitle title={"User Settings | Settings"} />
                <h2 className="page-title">User Settings</h2>
                <OrganisationName />
                <PopupBox />
                <UserForm mode="update" id={0} closeEditPanel={() => {}} updatePopupCallback={this.updatePopupCallback} />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  static getDerivedStateFromProps(props, state) {
    // Reporting, and Emergency can't edit their settings yet
    // Managers can visit Appointments and Mobile Enrolment settings
    if (!adminUser() && !managerUser()) {
      return {
        page: "index"
      }
    }

    // Render sidebar page based on URL
    if (props.history.location.pathname.endsWith("/organisation")) {
      return {
        page: "organisation"
      }
    }
    else if (props.history.location.pathname.includes("/location")) {
      return {
        page: "location"
      }
    }
    else if (props.history.location.pathname.includes("/fire-log")) {
      return {
        page: "fire-log"
      }
    }
    else if (props.history.location.pathname.includes("/appointments")) {
      return {
        page: "appointments"
      }
    }
    else if (props.history.location.pathname.includes("/email-templates")) {
      return {
        page: "email-templates"
      }
    }
    else if (props.history.location.pathname.includes("/users")) {
      return {
        page: "users"
      }
    }
    else if (props.history.location.pathname.includes("/integrations")) {
      return {
        page: "integrations"
      }
    }
    else if (props.history.location.pathname.includes("/enrolment")) {
      return {
        page: "enrolment"
      }
    }
    else if (props.history.location.pathname.includes("/data-retention")) {
      return {
        page: "data-retention"
      }
    }
    else if (props.history.location.pathname.includes("/tidy-up")) {
      return {
        page: "tidy-up"
      }
    }
    else {
      return {
        page: "index"
      }
    }
  }
}

export default SettingsIndex;
